module.exports = __webpack_public_path__ + "img/copy-serum-active-icon.1f7ae709.svg";